export default "__VITE_ASSET__CdCNcSiN__"